// eslint-disable-next-line import/prefer-default-export
export const PHONE_STATUS_ICONS = {
  not_configured: 'fa-regular fa-triangle-exclamation',
  unavailable: 'fa-regular fa-ban',
  inactive: 'fa-regular fa-circle-pause',
  active: 'fa-regular fa-shield-check'
}
